import HomeCard from "./homeCard";
import PopUpFormContribute from "../../../popUpForms/popUpFormContribute";
const CardContributeToTheCause = ({ hoveredTab, onTabHover, onTabLeave }) => {
  return (
    <HomeCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="contribute"
      title="Contribute to the Cause"
      titleColor="var(--cornflower-blue)"
      popUpComponent={<PopUpFormContribute />}
      content={[
        {
          type: "paragraph",
          text: "We invite reciprocity to help future beneficiaries using this toolset by collaborating to improve it.",
          color: "var(--white)",
        },
        {
          type: "paragraph",
          text: "To improve communities' wildfire resilience overall through scorecard enhancements and adoption, ARISE-US/CrowdDoing CWPC invite corporations and institutions to support this effort.",
          color: "var(--white)",
        },
        {
          type: "button",
          color: "var(--cornflower-blue)",
          text: "Support Wildfire Prevention",
        },
      ]}
    />
  );
};

export default CardContributeToTheCause;
